<template>
  <div class="news1-box">
    <div class="bgPic">
      <div class="picText">
        <span class="title">数字化运营服务商，全渠道数字化信息平台</span><br>
        <span>为企业提供专业、高效的服务</span>
      </div>
      <!-- <div class="pic">
        <img
          src="@/assets/last/bg/新闻资讯banner.png"
          alt=""
          style="height: 870px; width: 100%"
        />
      </div> -->
    </div>
    <!--  -->
    <div class="box">
                 <p><el-button type="text" @click="goNews(0)">新闻动态</el-button> ><el-button type="text">动态详情</el-button>  </p>

      <div class="card" id="card">
        <el-card class="box-card">
          <div slot="header" class="title">
            <p>喜报丨“泽润软件”获2025年ISO27001信息安全管理体系认证、三级等保认证</p>
            <span class="time">发布时间：2025-03-03</span>
            <span>阅读量：{{ number }}</span>
          </div>
          <div class="content">
            <p>
                喜报：深圳市泽润数字软件运营有限公司通过了2025年度ISO27001信息安全管理体系认证、信息安全等级保护三级测评，标志着泽润软件在完善信息安全管理规范和安全体系、提高安全建设、增强信息系统安全保护等方面,有了实质性提升,鉴于应用软件开发、运维及线上运行过程的信息价值及敏感性日益重要,信息安全已成为泽润软件的核心竞争力之一。
          </p>
            <p>
             在信息化时代，网络安全已经上升为一切互联网活动的基础条件之一，泽润软件始终秉承“致力于为客户提供数字化 解决方案，成为顾客信赖的伙伴”的使命，公司重视信息安全，始终保持IT行业先进技术，为实现数字化可持续发展， 紧跟互联网发展和数字化科技进步的步伐，公司重视研发投入及发展，始终投入大量资源开展研发，引领技术进步，保 障公司产品的创新力及市场竞争力；将信息安全维护和管理固化到企业运营、客户服务、技术研发的方方面面。
           </p>
            <div class="imgs img-pd">
              <img src="@/assets/last/certificate/ISO1.jpg" alt="" /><br>
              <span>ISO27001信息安全管理体系认证</span>
            </div>
            <p>
             在未来泽润软件将秉承着做专、做强成为顾客值得信赖的伙伴，持续深挖应用需求，以科技驱动数字化运营、营销服务方案，不断探索新的技术领域，加大基础研发平台的投入力度，通过系统与服务的不断优化升级，构建全链路智慧数字管理体系，不断提升数字化服务、管理效益，在各个行业中的应用。
            </p>
            <div class="imgs img-pd">
              <img src="@/assets/last/certificate/ISO2.jpg" alt="" /><br>
              <span> 深圳市信息安全等级保护测评结果通知书</span>

            </div>
            <!-- <span>客服系统：</span><br /> -->
           
          </div>
        </el-card>
      </div>
      <div class="link">
       <div class="left">
        <!-- <span>上一篇： </span>
        <el-button type="text" @click="goNews(1)">AICM智能会员管理系统全新升级</el-button> -->
        </div>
      <div class="right">
           <span>下一篇： </span>
        <el-button type="text" @click="goNews(2)"
          >AICM智能会员管理系统全新升级</el-button
        >
      </div>
      </div>
    </div>
      <!-- <div class="footer"></div> -->
      <BottomFooter />

  </div>
</template>

<script>
import BottomFooter from '../bottom.vue'

export default {
  name: "DemoNews3",
  components: {
    BottomFooter
  },
  data() {
    return {
      number: 36,
    };
  },
  created() {this.number += 1;this.getScoll()},
activated() {
    this.number += 1;
},
  mounted() {
    this.number += 1;
  },

  methods: {
    goNews(type) {
      this.$emit("toggle", type);
    },
     // 滚动
     getScoll(point){
      this.$nextTick(() => {
        // 获取元素
        const scrollTop = document.getElementById('card').offsetTop // 获取需要滚动的距离
        // 元素自身高度
        // const height = document.getElementById(point).offsetHeight
        document.documentElement.scrollTop = scrollTop+600
      })
      
    }
  },
};
</script>

<style lang="less" scoped>
.news1-box {
  .bgPic{
         background: url("../../assets/last/bg/优秀案例背景.png") no-repeat;
    background-size: cover;
    height: 870px;
    }
  .picText {
    color: rgb(242, 243, 247);
    text-align: center;
    letter-spacing: 3px;
    line-height: 80px;
    font-family: SourceHanSansCN-Regular-;
    padding-top: 300px;
    .title {
      display: inline-block;
      font-size: 60px;
      font-weight: normal;
      letter-spacing: 7px;
    }

    span {
      font-size: 40px;
    }
    :hover{
      color: rgba(110, 87, 229);
    }
  }
 .box {
    position: relative;
    text-align: left;
    width: 60%;
    margin: 100px auto;
     line-height: 36px;
        font-size: 20px;
.el-button--text {
  font-size: 20px;
 color: #5b5b5b;

}
    .title {
      font-size: 18px;
      color: #5b5b5b;
      p {
        font-size: 30px;
        color: #333333;
      }
      .time {
        display: inline-block;
        padding-right: 60px;
      }
    }
    .content {
        padding: 0 30px;
      p {
        letter-spacing:1px;
        word-spacing:　2px;
        line-height:1.7;
        text-align:　justify;
        text-indent: 2em;
      }
      .imgs {
        margin: auto;
        text-align: center;
        span {
          display: inline-block;
          padding-top: 30px;
        }
        img{
          width: 80%;
        }
      }
      .img-pd {
        margin: 100px auto;
      }
    }
    .link {
      padding: 50px 0 0;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 18px;
      }
      .el-button--text {
  font-size: 20px;
 color: rgb(73, 151, 237);

}
    }
  }
//   .footer{
//     background: url("../../assets/last/bg/底部.png") no-repeat;
//     background-size: contain;
//     height: 550px;
//   }
}
</style>